module.exports = __webpack_public_path__ + "img/hb-back.527ddfb2.png";